"use client"

import DashboardLayout from "../dashboard/DashboardLayout"
import { useNavigate } from "react-router-dom"
import ResultsHistory from './ResultsHistory'

export default function ResultsHistoryPage() {
  const navigate = useNavigate()
  


  return (
    <DashboardLayout>
      <ResultsHistory
      onViewDetails={
        (id)=>{
          navigate(`${id}`)
        }
      }
      />
    </DashboardLayout>
  )
}
